import { render, staticRenderFns } from "./ConvenioFederalDetalheModal.vue?vue&type=template&id=61aaccfe&"
import script from "./ConvenioFederalDetalheModal.vue?vue&type=script&lang=js&"
export * from "./ConvenioFederalDetalheModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61aaccfe')) {
      api.createRecord('61aaccfe', component.options)
    } else {
      api.reload('61aaccfe', component.options)
    }
    module.hot.accept("./ConvenioFederalDetalheModal.vue?vue&type=template&id=61aaccfe&", function () {
      api.rerender('61aaccfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/convenios-federais/ConvenioFederalDetalheModal.vue"
export default component.exports